//  UserConfiguration.js
//
//  Updated 2/3.
//
//  Abstract: User configuration page.

//	React
import React, { useState } from 'react';
import clsx from 'clsx';
import axios from 'axios';
import { authMiddleware } from '../../../services/auth/auth.js';

//	Material-ui components
import { makeStyles, Card, Typography, CircularProgress, CardActions, CardContent, Divider, Button, Grid, TextField } from '@material-ui/core';

//	CSS Styles
const useStyles = makeStyles((theme) => ({
	content: {
		flexGrow: 1,
		padding: theme.spacing(3)
	},
	toolbar: theme.mixins.toolbar,
	root: {},
	details: {
		display: 'flex'
	},
	locationText: {
		paddingLeft: '15px'
	},
	uiProgess: {
		position: 'fixed',
		zIndex: '1000',
		height: '31px',
		width: '31px',
		left: '50%',
		top: '35%'
	},
	progess: {
		position: 'absolute'
	},
	customError: {
		color: 'red',
		fontSize: '0.8rem',
		marginTop: 10
	},
	submitButton: {
		marginTop: '10px'
	}
}));

export default function AccountConfiguration(props) {

	//  CSS styles
	const classes = useStyles();

	//	Set state
	const [firstName, setFirstName] = useState('');
	const [lastName, setLastName] = useState('');
	const [organization, setOrganization] = useState('');
	const [email, setEmail] = useState('');
	const [password, setPassword] = useState('');
	const [confirmPassword, setConfirmPassword] = useState('');
	const [errors, setErrors] = useState([]);
	const [isUiLoading, setIsUiLoading] = useState(false);
	const [isButtonLoading, setIsButtonLoading] = useState(false);

	//	Event handlers
	function handleFirstNameChange(event) {
		setFirstName(event.target.value);
	}
	function handleLastNameChange(event) {
		setLastName(event.target.value);
	}
	function handleOrganizationChange(event) {
		setOrganization(event.target.value);
	}
	function handleEmailChange(event) {
		setEmail(event.target.value);
	}
	function handlePasswordChange(event) {
		setPassword(event.target.value);
	}
	function handleConfirmPasswordChange(event) {
		setConfirmPassword(event.target.value);
	}
	function handleErrorsChange(event) {
		setErrors([event.target.value]);
	}
	function handleFormSubmit(event) {
		event.preventDefault();
		setIsButtonLoading(true);
		authMiddleware(props.history);
		const authToken = localStorage.getItem('AuthToken');
		axios.defaults.headers.common = { Authorization: `${authToken}` };
		const formRequest = {
			firstName: firstName,
			lastName: lastName,
		};
		axios
			.post('/user', formRequest)
			.then(() => {
				setIsButtonLoading(false);
			})
			.catch((error) => {
				if (error.response.status === 403) {
					props.history.push('/login');
				}
				console.log(error);
				setIsButtonLoading(false);
			});
	};

	//	Render spinner on loading
	if (isUiLoading) {
		return (
			<main className={classes.content}>
				<div className={classes.toolbar} />
				{isUiLoading && <CircularProgress size={16} className={classes.uiProgess} />}
			</main>
		);
	} else {
		//	Render component if loaded
		return (
			<main className={classes.content}>
				<div className={classes.toolbar} />
				<Card className={clsx(classes.root, classes)}>
					<CardContent>
						<div className={classes.details}>
							<div>
								<Typography className={classes.locationText} gutterBottom variant="h4">
									{firstName} {lastName}
								</Typography>

							</div>
						</div>
						<div className={classes.progress} />
					</CardContent>
					<Divider />
				</Card>
				<br />
				<Card className={clsx(classes.root, classes)}>
					<form autoComplete="off" noValidate>
						<Divider />
						<CardContent>
							<Grid container spacing={3}>
								<Grid item md={6} xs={12}>
									<TextField
										fullWidth
										label="First name"
										margin="dense"
										name="firstName"
										variant="outlined"
										value={firstName}
										onChange={handleFirstNameChange}
									/>
								</Grid>
								<Grid item md={6} xs={12}>
									<TextField
										fullWidth
										label="Last name"
										margin="dense"
										name="lastName"
										variant="outlined"
										value={lastName}
										onChange={handleLastNameChange}
									/>
								</Grid>
								<Grid item md={6} xs={12}>
									<TextField
										fullWidth
										label="Email"
										margin="dense"
										name="email"
										variant="outlined"
										disabled={true}
										value={email}
										onChange={handleEmailChange}
									/>
								</Grid>
								<Grid item md={6} xs={12}>
									<TextField
										fullWidth
										label="Organization"
										margin="dense"
										name="organization"
										variant="outlined"
										disabled={true}
										value={organization}
										onChange={handleOrganizationChange}
									/>
								</Grid>
							</Grid>
						</CardContent>
						<Divider />
						<CardActions />
					</form>
				</Card>
				<Button
					color="primary"
					variant="contained"
					type="submit"
					className={classes.submitButton}
					onClick={handleFormSubmit}
					disabled={
						isButtonLoading ||
						!firstName ||
						!lastName ||
						!organization
					}
				>
					Save Account Details
						{isButtonLoading && <CircularProgress size={15} className={classes.progess} />}
				</Button>
			</main>
		)
	}
}